/**
 * Boxful Fulfillment 2026 home page - global expansion hub & cross-border AI diagnostic
 * Source design: boxful_app/ (static mockup)
 */

// Global Expansion Hub Data
const countryData = {
  vn: {
    flag: '🇻🇳',
    name: '베트남 (Vietnam)',
    sub: '동남아 K-뷰티 & 라이프스타일 1위 핵심 거점',
    services: [
      {
        icon: '🏛️',
        title: '현지 법인 설립 & 파트너십 연계',
        desc: '하노이/호치민 지사 설립 대행, Ship60 / 로컬 물류사 원스톱 비즈니스 업무협약 지원',
        tag: '법인 대행 5~6주'
      },
      {
        icon: '🚢',
        title: '수출 포워딩 & 성분 사전 승인',
        desc: '화장품/식품 현지 성분 심의, 세관 통관 전용 서류 준비 및 전용 컨테이너/항공 포워딩',
        tag: '성분 심의 원스톱'
      },
      {
        icon: '🏪',
        title: '현지 Top 쇼핑몰 계정 연동',
        desc: 'Shopee Vietnam (65%), Lazada VN (22%), TikTok Shop VN 공식 셀러 계정 및 마케팅 연동',
        tag: '쇼핑몰 입점 100%'
      },
      {
        icon: '📦',
        title: '현지 Boxful 풀필먼트 & 로컬배송',
        desc: '하노이/호치민 1,000평 물류센터 보관 & NinjaVan, GHN, GHTK 로컬 당일/익일 배송망 연동',
        tag: '로컬 WMS 연계'
      }
    ]
  },
  tw: {
    flag: '🇹🇼',
    name: '대만 (Taiwan)',
    sub: '높은 구매력과 K-브랜드 선호도 최고 시장',
    services: [
      {
        icon: '🏛️',
        title: '대만 법인 설립 & 현지 CS 대응',
        desc: '타이페이 법인 등록 및 번체 중국어 상품 상세페이지 번역/현지 고객 CS 전담팀 연계',
        tag: '현지화 원스톱'
      },
      {
        icon: '🚢',
        title: 'K-뷰티/푸드 통관 패스트트랙',
        desc: '대만 세관 규정에 맞춘 정식 수입 라벨링 및 항공/해운 신속 포워딩 통관',
        tag: '통관 패스트트랙'
      },
      {
        icon: '🏪',
        title: '대만 대표 쇼핑몰 자동 연동',
        desc: 'Shopee TW, MOMO Shop (48%), PChome 24h (31%) 마켓플레이스 판매 연동',
        tag: '주요 채널 100% 연동'
      },
      {
        icon: '📦',
        title: '타이페이 4,000평 풀필먼트 & 배송',
        desc: 'K-뷰티 특화 4,000평 풀필먼트 입고 & 7-Eleven 편의점 택배, Black Cat 픽업 연동',
        tag: '대형 센터 보관'
      }
    ]
  },
  hk: {
    flag: '🇭🇰',
    name: '홍콩 (Hong Kong)',
    sub: '아시아 프리미엄 K-브랜드 거점 & 무관세 허브',
    services: [
      {
        icon: '🏛️',
        title: '홍콩 법인 등록 & 글로벌 금융계좌',
        desc: '글로벌 비즈니스를 위한 홍콩 법인 설립 및 다국적 외환 금융 계좌 개설 지원',
        tag: '무관세 허브'
      },
      {
        icon: '🚢',
        title: '당일/특급 항공 포워딩 배송',
        desc: '인천-홍콩 직항 포워딩 및 세관 무관세 소형 화물 당일 세관 통관',
        tag: '당일 통관 연계'
      },
      {
        icon: '🏪',
        title: '모바일 커머스 & 마케팅 연동',
        desc: 'HKTVmall, Shopee HK, 브랜드 자사몰 연동 & 현지 인플루언서 네트워크 연결',
        tag: '모바일 커머스'
      },
      {
        icon: '📦',
        title: '콰이청 물류센터 & SF Express',
        desc: '콰이청 물류센터 보관 & SF Express, FedEx 당일 직배송 시스템',
        tag: '프리미엄 센터'
      }
    ]
  },
  uz: {
    flag: '🇺🇿',
    name: '우즈베키스탄 (Uzbekistan)',
    sub: '중앙아시아 K-제품 수요 폭발적 성장 거점',
    services: [
      {
        icon: '🏛️',
        title: '타슈켄트 법인 설립 & 마케팅 연계',
        desc: '우즈베키스탄 현지 법인 설립 및 K-제품 전담 마케팅 파트너십 구축',
        tag: '중앙아시아 거점'
      },
      {
        icon: '🚢',
        title: '특화 포워딩 & 현지 관세 통관',
        desc: '복잡한 현지 통관 규정 라벨링 처리 및 안전 항공/육상 복합 포워딩',
        tag: '전문 통관'
      },
      {
        icon: '🏪',
        title: '현지 1위 유통 채널 입점',
        desc: 'Uzum Market, ZoodMall, Telegram 공식 쇼핑 채널 연동',
        tag: '현지 1위 채널 연동'
      },
      {
        icon: '📦',
        title: '타슈켄트 500평 센터 & Express 24',
        desc: '500평 규모 최신 센터 입고 및 Uzum 물류, Express 24 배송망 연결',
        tag: '현지 풀필먼트'
      }
    ]
  },
  us: {
    flag: '🇺🇸 🇯🇵',
    name: '미국 / 일본 (USA & Japan)',
    sub: '글로벌 대형 이커머스 시장 진출 확장',
    services: [
      {
        icon: '🏛️',
        title: 'US/JP 법인 & FDA/PMDA 성분 등록',
        desc: '미국 FDA / 일본 PMDA 성분 사전 검토 및 현지 법인/수입업자 등록 대행',
        tag: 'FDA/PMDA 사전 승인'
      },
      {
        icon: '🚢',
        title: 'FBA / FBM 전용 해운·항공 포워딩',
        desc: '대형 컨테이너 해운 및 항공 특송 포워딩, 통관 보세창고 연계',
        tag: '글로벌 포워딩'
      },
      {
        icon: '🏪',
        title: 'Amazon US / Qoo10 JP / Rakuten',
        desc: '아마존 US, 큐텐 재팬, 라쿠텐 상점 개설 및 카테고리 승인 연동',
        tag: '글로벌 1위 마켓'
      },
      {
        icon: '📦',
        title: 'FBA Prep & Boxful 글로벌 풀필먼트',
        desc: '아마존 FBA 라벨링 Prep 및 미국/일본 현지 풀필먼트 센터 입고 대행',
        tag: 'FBA Prep 연동'
      }
    ]
  }
};

// Select Country Function
function selectCountry(countryCode) {
  const data = countryData[countryCode];
  if (!data) return;

  // Update tab buttons
  const buttons = document.querySelectorAll('.country-tab-btn');
  buttons.forEach(btn => {
    btn.classList.remove('active');
    if (btn.getAttribute('data-country') === countryCode) {
      btn.classList.add('active');
    }
  });

  const box = document.getElementById('countryServiceBox');
  if (!box) return;

  let serviceCardsHtml = '';
  data.services.forEach(s => {
    serviceCardsHtml += `
      <div class="service-card-item">
        <span class="s-icon">${s.icon}</span>
        <span class="service-tag-badge">${s.tag}</span>
        <h4>${s.title}</h4>
        <p>${s.desc}</p>
      </div>
    `;
  });

  box.innerHTML = `
    <div class="country-header-flex">
      <div class="country-title-box">
        <span class="c-flag">${data.flag}</span>
        <div>
          <h3 class="c-name">${data.name}</h3>
          <span class="c-sub">${data.sub}</span>
        </div>
      </div>
    </div>

    <div class="service-cards-grid">
      ${serviceCardsHtml}
    </div>

    <div class="country-action-bar">
      <div>
        <h4>🚀 ${data.name} 쇼핑몰 진출 원스톱 패키지 연결 신청</h4>
        <p>법인설립 + 포워딩 + 성분심의 + 현지 쇼핑몰 입점 + 현지 센터 연결을 Boxful이 한번에 진행해 드립니다.</p>
      </div>
      <button onclick="requestCountryPackage('${data.name}')" class="btn btn-mint btn-lg">
        📦 ${data.name} 원스톱 진출 견적/상담 요청
      </button>
    </div>
  `;
}

// Request Country Package Handler
function requestCountryPackage(countryName) {
  const contactSec = document.getElementById('contact');
  if (contactSec) {
    contactSec.scrollIntoView({ behavior: 'smooth' });

    const msgBox = document.getElementById('cMessage');
    const selectBox = document.getElementById('cTargetCountry');
    if (msgBox) {
      msgBox.value = `[${countryName} 해외 진출 원스톱 패키지 신청]\n- 현지 법인 설립 대행\n- 수출 포워딩 & 통관 라벨링\n- 현지 쇼핑몰(Shopee/Lazada/Amazon 등) 연동\n- Boxful 현지 센터 풀필먼트 원스톱 연결 상담 부탁드립니다.`;
    }
    if (selectBox) {
      selectBox.value = 'global-one-stop';
    }
  }
}

// ==========================================================================
// Boxful Cross-Border Big Data Global AI Diagnostic Engine
// ==========================================================================
async function calculateGlobalMarketFit(event) {
  if (event) event.preventDefault();

  const url = document.getElementById('diagUrl') ? document.getElementById('diagUrl').value.trim() : '';
  const category = document.getElementById('diagCategory') ? document.getElementById('diagCategory').value : 'beauty';
  const volume = document.getElementById('diagVolume') ? document.getElementById('diagVolume').value : '500-1000';
  const price = document.getElementById('diagPrice') ? document.getElementById('diagPrice').value : 'tier2';
  const targetType = document.getElementById('diagTargetType') ? document.getElementById('diagTargetType').value : 'marketplace';

  const loadingElem = document.getElementById('diagLoading');
  const resultCard = document.getElementById('diagResultCard');

  if (loadingElem) loadingElem.classList.remove('hidden');
  if (resultCard) resultCard.classList.add('hidden');

  // Simulate Big Data Processing
  await new Promise(r => setTimeout(r, 700));

  if (loadingElem) loadingElem.classList.add('hidden');

  // Diagnostic Matrix based on Boxful Real-world Data
  const categoryProfiles = {
    beauty: {
      name: "K-뷰티 / 스킨케어 / 화장품",
      top1: { code: 'tw', flag: '🇹🇼', country: '대만 (Taiwan)', score: 96 },
      top2: { code: 'hk', flag: '🇭🇰', country: '홍콩 (Hong Kong)', score: 91 },
      top3: { code: 'vn', flag: '🇻🇳', country: '베트남 (Vietnam)', score: 86 },
      insight: "박스풀 한국·대만·홍콩 물류센터의 고객 데이터 분석 결과, 입력하신 [K-뷰티] 품목의 현지 거주자 및 외국인 고객 재구매율이 일반 품목 대비 +45% 높게 집계되었습니다. 특히 대만 Shopee TW 및 MOMO 쇼핑몰에서 한국 기초 스킨케어의 구매 전환율이 상위 3% 수준입니다.",
      channels: "대만 Shopee TW + MOMO 쇼핑몰 + 왓슨스(Watsons) 팝업",
      sol: "대만 현지 화장품 성분 사전 승인(TFDA) + 법인설립 + 대만 Boxful 풀필먼트 연계"
    },
    health: {
      name: "건강기능식품 / 이너뷰티 / 다이어트",
      top1: { code: 'vn', flag: '🇻🇳', country: '베트남 (Vietnam)', score: 95 },
      top2: { code: 'hk', flag: '🇭🇰', country: '홍콩 (Hong Kong)', score: 89 },
      top3: { code: 'tw', flag: '🇹🇼', country: '대만 (Taiwan)', score: 84 },
      insight: "베트남 및 홍콩 거주 외국인/중산층의 한국산 건강기능식품(콜라겐, 유산균, 홍삼 등) 주문액이 전년 대비 130% 급증했습니다. 박스풀 베트남 호치민/하노이 포워딩 및 현지 통관 심의를 통해 가장 빠른 매출 성장이 예상됩니다.",
      channels: "베트남 Shopee VN + TikTok Shop + 현지 약국 체인 연계",
      sol: "베트남 보건부(MOH) 식품 안전 인증 + 로컬 통관 대행 + 동남아 전용 특송 풀필먼트"
    },
    fashion: {
      name: "K-패션 / 디자이너 의류 / 잡화",
      top1: { code: 'tw', flag: '🇹🇼', country: '대만 (Taiwan)', score: 94 },
      top2: { code: 'us', flag: '🇯🇵/🇺🇸', country: '일본 / 미국', score: 90 },
      top3: { code: 'hk', flag: '🇭🇰', country: '홍콩 (Hong Kong)', score: 85 },
      insight: "한국 내 거주 중인 대만/일본인 유학생 및 관광객 구매 이력 분석 상, 한국 디자이너 브랜드 의류의 장바구니 전환율이 38%에 달합니다. 대만 패션 트렌드가 한국과 95% 동기화되어 있어 즉각적인 반응이 나타납니다.",
      channels: "대만 Shopee + 일본 큐텐(Qoo10) / 조조타운 + 인스타그램 쇼핑",
      sol: "반품/교환 케어가 필수적인 패션 특화 양품화 풀필먼트 + 항공 특송 패키지"
    },
    food: {
      name: "K-Food / 가공식품 / 스낵 / 소스",
      top1: { code: 'tw', flag: '🇹🇼', country: '대만 (Taiwan)', score: 95 },
      top2: { code: 'us', flag: '🇺🇸', country: '미국 (USA)', score: 92 },
      top3: { code: 'vn', flag: '🇻🇳', country: '베트남 (Vietnam)', score: 88 },
      insight: "대만 및 미국 서부 한인/현지인 마켓에서 K-Food 가공스낵 및 소스류 수요가 폭발적입니다. 박스풀의 항온·항습 광주센터 보관과 국제 식품검역 지원으로 안전한 수출이 가능합니다.",
      channels: "대만 까르푸/세븐일레븐 + 미국 Amazon US + 한인 H마트 온/오프라인",
      sol: "식품 검역 라벨링 + 수출용 박스 완충 포장 + 미국/대만 현지 3PL 풀필먼트"
    },
    goods: {
      name: "캐릭터 굿즈 / 팬시 / K-POP 문구",
      top1: { code: 'tw', flag: '🇹🇼', country: '대만 (Taiwan)', score: 97 },
      top2: { code: 'us', flag: '🇺🇸/🇯🇵', country: '미국 / 일본', score: 93 },
      top3: { code: 'hk', flag: '🇭🇰', country: '홍콩 (Hong Kong)', score: 88 },
      insight: "외국인 관광객 및 크로스보더 주문 빅데이터에서 캐릭터 굿즈는 객단가 대비 배송비 민감도가 가장 낮고 수집욕 기반 재구매율이 65%에 달합니다. 대만과 북미 팬덤 시장에서 독보적입니다.",
      channels: "글로벌 Shopee + 미국 Amazon + K-POP 팬덤 커뮤니티 직판",
      sol: "한정판 상품 개별 바코드 검수 + 파손방지 특수 에어캡 포장 + 글로벌 B2C 특송"
    },
    living: {
      name: "소형 리빙 / 생활가전 / 아이디어 상품",
      top1: { code: 'hk', flag: '🇭🇰', country: '홍콩 (Hong Kong)', score: 92 },
      top2: { code: 'tw', flag: '🇹🇼', country: '대만 (Taiwan)', score: 89 },
      top3: { code: 'uz', flag: '🇺🇿', country: '우즈베키스탄 / CIS', score: 85 },
      insight: "홍콩 및 대만의 1인 가구 증가로 소형 리빙 및 스마트 아이디어 가전의 수요가 매우 높습니다. 높은 1인당 GDP를 바탕으로 프리미엄 가격대 수용도가 뛰어납니다.",
      channels: "홍콩 HKTVmall + 대만 MOMO + 쇼피 라이브 커머스",
      sol: "전자파/안전인증 대행 + 현지 A/S 반품 양품화 거점 + 박스풀 홍콩 센터 연계"
    }
  };

  const prof = categoryProfiles[category] || categoryProfiles.beauty;

  // Estimated Revenue Multiplier Calculation
  let baseRev = 1500;
  if (volume === '1000-3000') baseRev = 2800;
  else if (volume === 'over3000') baseRev = 4500;
  else if (volume === 'under500') baseRev = 850;

  if (price === 'tier3') baseRev = Math.round(baseRev * 1.3);
  if (price === 'tier4') baseRev = Math.round(baseRev * 1.6);

  // Render Result Card HTML
  if (resultCard) {
    resultCard.innerHTML = `
      <div class="diag-result-header">
        <div style="display: flex; align-items: center;">
          <span class="diag-winner-flag">${prof.top1.flag}</span>
          <div>
            <span style="font-size: 12px; color: var(--point-mint-dark); font-weight: 700; text-transform: uppercase;">1순위 최적 추천 진출 국가</span>
            <h3 style="font-size: 24px; font-weight: 900; color: var(--primary);">${prof.top1.country}</h3>
          </div>
        </div>
        <div class="diag-score-pill">
          <span>시장 적합도</span>
          <strong>${prof.top1.score}점 / 100점</strong>
        </div>
      </div>

      <!-- Rank Cards Row -->
      <div class="diag-ranks-row">
        <div class="rank-card top1">
          <span class="rank-flag">${prof.top1.flag}</span>
          <span class="rank-name">1위: ${prof.top1.country}</span>
          <span class="rank-score">적합도 ${prof.top1.score}점 (압도적 추천)</span>
        </div>
        <div class="rank-card">
          <span class="rank-flag">${prof.top2.flag}</span>
          <span class="rank-name">2위: ${prof.top2.country}</span>
          <span class="rank-score">적합도 ${prof.top2.score}점 (유력 후보)</span>
        </div>
        <div class="rank-card">
          <span class="rank-flag">${prof.top3.flag}</span>
          <span class="rank-name">3위: ${prof.top3.country}</span>
          <span class="rank-score">적합도 ${prof.top3.score}점 (동반 확장)</span>
        </div>
      </div>

      <!-- Big Data Insight Box -->
      <div class="diag-insight-box">
        <h4>📊 박스풀 아시아 실구매 빅데이터 교차 분석 인사이트</h4>
        <p>${prof.insight}</p>
      </div>

      <!-- Metrics Row -->
      <div class="diag-metrics-grid">
        <div class="diag-metric-box">
          <strong>🚀 추천 해외 진출 채널</strong>
          <span class="metric-value" style="font-size: 15px; color: #0369a1;">${prof.channels}</span>
        </div>
        <div class="diag-metric-box">
          <strong>💰 예상 월 해외 추가 매출 잠재력</strong>
          <span class="metric-value" style="color: var(--point-mint-dark);">월 약 +${baseRev.toLocaleString()}만원</span>
        </div>
      </div>

      <!-- Recommended Boxful Package -->
      <div style="background: var(--bg-light); border: 1px solid var(--border-color); border-radius: var(--radius-sm); padding: 18px; margin-bottom: 24px;">
        <strong style="font-size: 14px; color: var(--primary); display: block; margin-bottom: 6px;">📦 박스풀 맞춤형 원스톱 진출 솔루션</strong>
        <p style="font-size: 13px; color: var(--text-muted);">${prof.sol}</p>
      </div>

      <!-- Action Banner -->
      <div class="diag-action-banner">
        <div>
          <h4>이 진단 결과를 바탕으로 해외 진출 & 풀필먼트 1:1 맞춤 견적을 받아보세요!</h4>
          <p>원클릭 시 아래 견적 신청 폼에 분석된 스토어 정보가 자동으로 적용됩니다.</p>
        </div>
        <button type="button" onclick="applyDiagnosticToContactForm('${prof.top1.country}', '${prof.name}', '${url}', '${volume}')" class="btn btn-mint btn-lg" style="box-shadow: 0 4px 14px rgba(0, 198, 178, 0.4);">
          🚀 1:1 맞춤 견적서 자동 신청하기 ➔
        </button>
      </div>
    `;

    resultCard.classList.remove('hidden');
    resultCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

// Auto-fill Contact Form from Diagnostic Results
function applyDiagnosticToContactForm(country, categoryName, url, volume) {
  const cUrl = document.getElementById('cUrl');
  const cCategory = document.getElementById('cCategory');
  const cTargetCountry = document.getElementById('cTargetCountry');
  const cVolume = document.getElementById('cVolume');
  const cMessage = document.getElementById('cMessage');

  if (cUrl && url) cUrl.value = url;
  if (cCategory) cCategory.value = categoryName;
  if (cTargetCountry) cTargetCountry.value = 'global-one-stop';
  if (cVolume && volume) cVolume.value = volume;
  if (cMessage) {
    cMessage.value = `[AI 진단 결과 연계 신청]\n추천 진출 국가: ${country}\n카테고리: ${categoryName}\n스토어 URL: ${url}\n\n박스풀의 아시아 구매 데이터 기반 맞춤 해외 풀필먼트 및 현지 진출 원스톱 패키지 상담을 요청합니다.`;
  }

  // Open collapsible form details
  const body = document.getElementById('skuCollapseBody');
  if (body && !body.classList.contains('open')) {
    toggleFormDetails();
  }

  // Smooth scroll to contact form
  const contactSection = document.getElementById('contact');
  if (contactSection) {
    contactSection.scrollIntoView({ behavior: 'smooth' });
  }

  alert(`✨ ${country} 진출 맞춤 진단 정보가 견적 신청 폼에 자동 입력되었습니다!\n\n성함과 연락처를 확인하신 후 [1:1 맞춤 비교견적 & 원스톱 진출 신청하기] 버튼을 눌러주시면 전담 매니저가 연락드립니다.`);
}
